var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[(_vm.titleVisible)?_c('PageTitle',{attrs:{"title":_vm.pageInfo.title,"description":_vm.pageInfo.description}}):_vm._e(),(_vm.navVisible)?_c('Nav',{staticClass:"nav",attrs:{"links":_vm.pageInfo.navLinks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }